
import { ZERO_PERCENT } from 'constants/misc'


export function useSwapTaxes(inputTokenAddress?: string, outputTokenAddress?: string) {
  //const fotDetector = useFeeOnTransferDetectorContract()
  //const [{ inputTax, outputTax }, setTaxes] = useState({ inputTax: ZERO_PERCENT, outputTax: ZERO_PERCENT })
  const inputTax = ZERO_PERCENT
  const outputTax = ZERO_PERCENT
  /*const chainId = useChainId()

  useEffect(() => {
    if (!fotDetector || !chainId) return
    getSwapTaxes(fotDetector, inputTokenAddress, outputTokenAddress, chainId).then(setTaxes)
  }, [fotDetector, inputTokenAddress, outputTokenAddress, chainId])*/

  return { inputTax, outputTax }
}
